import React, { useEffect, useState } from "react";
import { getSingleAppointment } from "service/appointments/operations.js";
import styled from "styled-components";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import media from "@/utils/media";
import LoadingIcon from "@/components/Loading";
import moment from "moment";
import Button from "@/components/ui/Button";
import { MaxConstraints } from "@/components/styled/layout";
import { Row, Col, Spin } from "antd";
import { getLocationOptions } from "./LocationSelector";

const StyledContainer = styled(Row)`
    font-family: Montserrat;
    // max-width: 90%;

    .title, .subtitle {
        // font-style: normal;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
    }
    .title{
        margin: 40px 0 40px 0;
        color:  var(--primary-main-color);
        font-weight: 700;
    }
    .mragain-section-title, .section-subtitle {
        // font-style: normal;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
    }
    .mragain-section-title{
        margin: 20px 0 0 0;
        color:  var(--primary-main-color);
        font-weight: 700;
    }
    .button-wrapper{
        display:flex;
        justify-content: center;
        margin-top: 16px;
    }

`
const ImageContainer = styled.div`
    display:flex;
    justify-content: center;
    .check-icon {
        display:flex;
        min-width: 87px;
        min-height: 87px;
    }
`;

const StyledBox = styled.div`
`
const Details = styled.div`
    display: flex;
`
const AppointmentSuccess = ({ shop, appointmentId, redirect_url }) => {
    const { name, street, st_number, city } = shop;
    const [appointment, setAppointment] = useState(null);
    const [loading, setLoading] = useState(true);

    //   const router = useRouter();


    useEffect(() => {
        window.scrollTo(0, 0);

        async function fetchAppointment(id) {
            if (!id) return null;
            const res = await getSingleAppointment(id, () => console.log("dispatch"));
            setAppointment(res);
            setLoading(false);
        }
        fetchAppointment(appointmentId);
    }, []);
    const handleFinish = (e) => {
        e.preventDefault()
        console.log('finish')
        if (redirect_url) {
            console.log('redirect...')
            window.location.href = redirect_url

        } else {
            console.log('reload...')
            window.location.reload()
        }
    }
    if (loading) {
        return <Spin />
    }
    const locationOptions = getLocationOptions(shop)
    const appointmentType = appointment.appointment?.appointment_type
    // console.log(locationOptions[appointmentType])
    const serviceType = (appointmentType && locationOptions[appointmentType].label) || 'n/a'
    const address = `${street} ${st_number}, ${city}`
    return (
        <StyledContainer type="flex" gutter={0}>
            <Col span={24}>
                <Row type="flex" justify="center">
                    <Col span={24}>
                        <ImageContainer>
                            <FontAwesomeIcon
                                className="check-icon"
                                color="var(--primary-main-color)"
                                icon={faCheckCircle}
                            ></FontAwesomeIcon>
                        </ImageContainer>
                    </Col>
                    <Col span={24} style={{ textAlign: "center" }}>
                        <StyledBox className="title">Afspraak gemaakt</StyledBox>
                    </Col>
                    <Col span={24} >
                        <StyledBox className="subtitle">
                            Je afspraak is gemaakt. We hebben je een e-mail ter bevestiging gestuurd.{" "}
                        </StyledBox>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                {!!appointment && (
                    <Row type="flex" justify="center">
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="mragain-section-title">Locatie</StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="section-subtitle">{serviceType}, {address}</StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="mragain-section-title">Datum  & tijd</StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="section-subtitle">
                                {appointment.appointment.date
                                    ? moment(appointment.appointment.date).format(
                                        "dddd, DD MMMM"
                                    )
                                    : "No date"}
                                , {appointment.appointment.time}
                            </StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="mragain-section-title">Apparaat</StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="section-subtitle">
                                {appointment.device.device_name}&nbsp;
                                {appointment.brand.brand_name}&nbsp;
                                {appointment.model?.model_name}
                            </StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="mragain-section-title">Reparatie</StyledBox>
                        </Col>
                        <Col span={24} style={{ textAlign: "center" }}>
                            <StyledBox className="section-subtitle">
                                {" "}
                                {appointment.reparation.reparation_name} | €
                                {appointment.price}
                            </StyledBox>
                        </Col>

                        <Col span={24} className="button-wrapper">
                            <Button onClick={handleFinish}>PRIMA!</Button>
                        </Col>
                    </Row>

                )}
            </Col>
        </StyledContainer>

    );
};

export default AppointmentSuccess;


